import { Box } from "@material-ui/core";
import { tokens } from "app/theme";
import { Link } from "react-router-dom";

export function InlineCountCard({
  title,
  count,
  path,
  suffix = "",
}: {
  title: string;
  count: number;
  path?: string;
  suffix?: string;
}) {
  const body = (
    <>
      <span style={{ font: `600 15px/1 ${tokens.fontMono}`, color: tokens.fg1 }}>
        {count.toLocaleString()}
        {suffix}
      </span>
      <span
        style={{
          font: `500 10px/1 ${tokens.fontMono}`,
          textTransform: "uppercase",
          letterSpacing: "0.06em",
          color: tokens.fg3,
        }}
      >
        {title}
      </span>
    </>
  );
  const style = {
    display: "inline-flex",
    alignItems: "baseline",
    gap: 7,
    textDecoration: "none",
  };
  return (
    <Box style={{ display: "inline-block", padding: "0 8px" }}>
      {path ? (
        <Link to={path} style={style}>
          {body}
        </Link>
      ) : (
        <span style={style}>{body}</span>
      )}
    </Box>
  );
}
